import {
  useTelemedicineForPediatricsActivationStatus,
  GET_TELEMEDICINE_FOR_PEDIATRICS_ELIGIBILITY_QUERY_KEY,
  TelemedicineForPediatricsEligibility
} from "#/components/telemedicine/pediatrics/hooks/useTelemedicineForPediatricsActivation"
import { useQueryClient } from "@tanstack/react-query"

function useCreateTelemedicineForPediatricsEligibilityOverride(): (data: TelemedicineForPediatricsEligibility) => void {
  const queryClient = useQueryClient()
  return (data: TelemedicineForPediatricsEligibility) => {
    queryClient.setQueryDefaults(GET_TELEMEDICINE_FOR_PEDIATRICS_ELIGIBILITY_QUERY_KEY, {
      staleTime: Infinity,
      cacheTime: Infinity
    })
    queryClient.setQueryData(GET_TELEMEDICINE_FOR_PEDIATRICS_ELIGIBILITY_QUERY_KEY, data)
  }
}

export function useTelemedicineForPediatricsMapper() {
  const availability = useTelemedicineForPediatricsActivationStatus()
  const override = useCreateTelemedicineForPediatricsEligibilityOverride()
  const isActivated = availability?.activationStatus === "activated"
  const isNeedsReactivation = availability?.activationStatus === "needs-reactivation"

  return {
    blueberry_activated: {
      value: isActivated || isNeedsReactivation,
      toggle: () => {
        if (isActivated || isNeedsReactivation) {
          override({
            eligibilityRecordId: null,
            registrationCompleted: false,
            enrollmentUrl: "",
            needsReactivation: false
          })
        } else {
          override({
            eligibilityRecordId: "1",
            registrationCompleted: true,
            enrollmentUrl: "www.testurl.com",
            needsReactivation: false
          })
        }
      }
    },
    blueberry_needs_reactivation: {
      value: isNeedsReactivation,
      toggle: () => {
        if (isNeedsReactivation) {
          override({
            eligibilityRecordId: "1",
            registrationCompleted: true,
            enrollmentUrl: "www.testurl.com",
            needsReactivation: false
          })
        } else {
          override({
            eligibilityRecordId: "1",
            registrationCompleted: true,
            enrollmentUrl: "www.testurl.com",
            needsReactivation: true
          })
        }
      }
    }
  }
}
